import React from "react";
import { motion } from "framer-motion";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import { seoConfig } from "../config";
import { HiBookOpen, HiCode, HiLightningBolt } from "react-icons/hi";

const Resources = () => {
  const comingSoonFeatures = [
    {
      icon: <HiBookOpen className="text-4xl" />,
      title: "Tutorials & Guides",
      description: "In-depth tutorials on web development, DevOps, and best practices"
    },
    {
      icon: <HiCode className="text-4xl" />,
      title: "Code Snippets",
      description: "Useful code snippets and templates for common development tasks"
    },
    {
      icon: <HiLightningBolt className="text-4xl" />,
      title: "Tools & Resources",
      description: "Curated list of tools, libraries, and resources I use daily"
    }
  ];

  return (
    <main className="min-h-screen">
      <SEO 
        title={seoConfig.pages.resources.title}
        description={seoConfig.pages.resources.description}
        keywords={seoConfig.pages.resources.keywords.join(", ")}
        url="/resources"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "name": seoConfig.pages.resources.title,
          "description": seoConfig.pages.resources.description,
          "url": `${seoConfig.siteUrl}/resources`
        }}
      />
      <Header />
      <section className="pt-32 pb-20">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="max-w-4xl mx-auto text-center"
          >
            <h1 className="text-5xl font-bold mb-6 text-gray-900 dark:text-white">Resources</h1>
            <p className="text-xl text-gray-600 dark:text-gray-400 mb-12">
              Exciting content coming soon! I'm working on curating valuable resources for the developer community.
            </p>

            <div className="grid md:grid-cols-3 gap-8 mb-12">
              {comingSoonFeatures.map((feature, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="glass-effect p-8 rounded-xl card-hover"
                >
                  <div className="text-gray-900 dark:text-white mb-4 flex justify-center">
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-semibold mb-3 dark:text-white">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400">
                    {feature.description}
                  </p>
                </motion.div>
              ))}
            </div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="glass-effect p-8 rounded-xl"
            >
              <p className="text-gray-700 dark:text-gray-300 text-lg">
                In the meantime, check out my{" "}
                <a
                  href="https://medium.com/@tusharsingh1991"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-900 dark:text-white hover:underline font-semibold"
                >
                  Medium blog
                </a>
                {" "}for technical articles and insights.
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default Resources;
